export const APP_VERSION = '1.0.0';
export const BUILD_NUMBER = 1;
export const BUILD_DATE = '2025-03-08'; 